import comp from "./ModalComponentWrapper";
export default comp;
